module.exports = __webpack_public_path__ + "static/media/BBE_Standard_wide_logo.5c0a37ec.png";